<script setup>
const props = defineProps({
    linkGreen: {
        type: Boolean,
    },
    link: {
        type: String,
        default: '',
    },
    class: {
        type: String,
        default: '',
    },
    event: {
        type: String,
        default: '',
    },
    client: {
        type: Boolean,
    },
});

const convertedHref = atob(props.link);
</script>

<template>
    <span class="m-base64Link">
        <a
            :class="{
                'm-base64Link__a--green': linkGreen,
                [props.class]: props.class,
            }"
            :data-event="event"
            :href="convertedHref"
            class="m-base64Link__a"
        >
            <slot/>
        </a></span>
</template>

<style lang="scss">
@use "styles";
</style>
